
export class GuidePost {

    id: number;
    media_url: string;
    title: string;
    strategy: string;
    objective: string;
    catalog: string;
    engagements: number;
    impressions: number;

    constructor() {
        this.id = 0;
        this.media_url = '';
        this.title = '';
        this.strategy = '';
        this.objective = '';
        this.catalog = '';
        this.engagements = 0;
        this.impressions= 0;
    }

}

